import { Box, Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { faCommentQuestion } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';

interface Props {}

const HelpSection: React.FC<Props> = () => {
  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      bg="var(--chakra-colors-yellow-90)"
      p={6}
      gap={2}
      borderRadius="lg"
      mb={16}
    >
      <FontAwesomeIcon
        icon={faCommentQuestion}
        style={{ height: '40px', width: '40px' }}
      />
      <Box>
        <Text textStyle="headingItem" textTransform="capitalize">
          Need Help?
        </Text>
        <Text textStyle="headingOverline">
          Our Support Page has all the information to guide you through your
          Morressier journey.
        </Text>
      </Box>
      <Link
        passHref={false}
        href={`https://support.morressier.com/knowledge`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ButtonText role="link" textStyle="headingItem">
          View Support Page
        </ButtonText>
      </Link>
    </Flex>
  );
};

export default HelpSection;
